// extracted by mini-css-extract-plugin
var _1 = "BirdviewCardPlaceholder-moduleplaceholder__y7fb0";
export { _1 as "placeholder" }
